/* SbyS product configurator. Renders the steps described in product.metafields.sbs.configurator
   (data embedded by snippets/sbs-configurator.liquid) and writes them as line item properties. */
(function () {
  'use strict';
  var uid = 0;

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v === null || v === undefined || v === false) return;
        if (k === 'text') n.textContent = v;
        else if (k === 'class') n.className = v;
        else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), v);
        else n.setAttribute(k, v === true ? '' : v);
      });
    }
    (kids || []).forEach(function (c) {
      if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return n;
  }

  function esc(s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }

  function Configurator(root) {
    var dataEl = root.querySelector('[data-sbs-config-data]');
    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('sbs-configurator: invalid data', e);
      return;
    }
    this.root = root;
    this.id = 'sbs' + ++uid;
    this.cfg = this.data.config || {};
    this.groups = this.data.groups || {};
    this.valueGroup = this.data.valueGroup || {};
    this.options = this.data.options || [];
    this.current = (this.data.current || []).slice();
    /* native options with a single value: fixed, shown as an info line, never a choice */
    this.single = {};
    var ov = this.data.optionValues || [];
    this.options.forEach(function (n, i) {
      if (ov[i] && ov[i].length === 1) this.single[n] = ov[i][0];
    }, this);
    /* "preselect": false (default): only explicit customer choices count, never the theme's current variant */
    this.pre = this.cfg.preselect === true;
    this.chosen = {};
    this.form = this.resolveForm();
    this.formId = this.form ? this.form.getAttribute('id') || '' : ''; /* form.id is shadowed by <input name="id"> */
    if (!this.formId) console.warn('sbs-configurator: product form not found, choices will not be added to the cart');
    this.steps = [];
    this.od = {};
    this.combos = this.data.variants || [];
    this.combosDone = !((this.data.variantsCount || 0) > this.combos.length);
    this.build();
    this.buildBlocks();
    this.bind();
    this.refresh();
    this.observe();
    this.loadVariants();
    this.updatePrice();
    root.classList.add('sbs-config--ready');
  }

  Configurator.prototype.resolveForm = function () {
    var f = this.data.formId && document.getElementById(this.data.formId);
    if (f && f.tagName === 'FORM') return f;
    var scope = this.root.closest('product-info') || this.root.closest('section') || document;
    return scope.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  };

  /* ---------- building ---------- */

  Configurator.prototype.build = function () {
    var box = this.root.querySelector('[data-sbs-steps]');
    var self = this;
    var defs = (this.cfg.steps || []).slice();
    if (this.cfg.reference === true) defs.push({ type: 'text', id: 'reference', label: 'Project / reference', required: false });
    defs.forEach(function (def, i) {
      if (!def || (!def.label && def.type !== 'note')) return;
      if (self.conds(def.show_if).some(function (c) {
        return c.step;
      }))
        self.stepDeps = true;
      var s = self.makeStep(def, i);
      if (!s) return;
      self.steps.push(s);
      box.appendChild(s.wrap);
    });
  };

  Configurator.prototype.makeStep = function (def, i) {
    var s = { def: def, i: i, key: this.id + '-' + i, inputs: [], visible: true };
    s.valueEl = el('span', { class: 'sbs-step__value' });
    s.titleEl = el('span', { text: def.label || '' });
    s.head = el('div', { class: 'form__label sbs-step__label', id: s.key + '-label' }, [
      s.titleEl,
      def.required || def.type === 'note' ? null : el('span', { class: 'sbs-step__opt', text: ' (optional)' }),
      s.valueEl,
    ]);
    s.errorEl = el('p', { class: 'sbs-error', role: 'alert', hidden: true });
    s.wrap = el('div', { class: 'sbs-step sbs-step--' + def.type, 'data-sbs-step': def.label || def.id || def.type });
    if (def.label) s.wrap.appendChild(s.head);
    var ok;
    if (def.type === 'material' || def.type === 'group') ok = this.buildMaterial(s);
    else if (def.type === 'select') ok = this.buildSelect(s);
    else if (def.type === 'radio') ok = this.buildRadio(s);
    else if (def.type === 'text') ok = this.buildText(s);
    else if (def.type === 'note') ok = this.buildNote(s);
    else ok = false;
    if (ok === false) return null;
    s.wrap.appendChild(s.errorEl);
    return s;
  };

  Configurator.prototype.propName = function (s) {
    return 'properties[' + (s.propLabel || s.def.label) + ']';
  };

  /* Cart property label of a material step: "Fabric" / "Leather" from the group name, else the step label */
  Configurator.prototype.materialLabel = function (s) {
    var n = (s.group && s.group.name) || '';
    if (/^fabric/i.test(n)) return 'Fabric';
    if (/^leather/i.test(n)) return 'Leather';
    return s.def.label;
  };

  Configurator.prototype.formAttr = function () {
    return this.formId || null;
  };

  Configurator.prototype.buildText = function (s) {
    var self = this;
    var input = el('input', {
      type: 'text',
      class: 'sbs-input',
      id: s.key + '-input',
      name: this.propName(s),
      form: this.formAttr(),
      'aria-labelledby': s.key + '-label',
      maxlength: '250',
      autocomplete: 'off',
      placeholder: s.def.placeholder || null,
      oninput: function () {
        self.clearError(s);
      },
    });
    s.inputs.push(input);
    s.focusEl = input;
    s.isComplete = function () {
      return input.value.trim() !== '';
    };
    s.message = 'Please fill in this field.';
    s.wrap.appendChild(input);
    if (s.def.requirement) {
      s.reqEl = el('p', { class: 'sbs-info sbs-req', 'aria-live': 'polite', hidden: true });
      s.condEl = el('p', { class: 'sbs-note sbs-cond', hidden: true });
      s.wrap.appendChild(s.reqEl);
      s.wrap.appendChild(s.condEl);
    }
  };

  /* static text (e.g. a surcharge or "mixed upholstery" note), usually with show_if; never required, no cart property */
  Configurator.prototype.buildNote = function (s) {
    if (!s.def.text) return false;
    s.wrap.appendChild(el('p', { class: 'sbs-note sbs-note--step', text: s.def.text }));
    s.isComplete = function () {
      return true;
    };
    s.message = '';
  };

  /* ---------- choice-dependent info (config.info + metafield sbs.option_info) ---------- */

  /* All info definitions: config.info (object or list) plus option_display.<option>.info (true or {depends_on, key}) */
  Configurator.prototype.infoList = function () {
    if (this._infos) return this._infos;
    var list = [];
    var seen = {};
    var add = function (c) {
      if (!c || typeof c !== 'object' || !c.option || seen[c.option]) return;
      seen[c.option] = true;
      list.push(c);
    };
    var ci = this.cfg.info;
    (Array.isArray(ci) ? ci : [ci]).forEach(add);
    var od = this.cfg.option_display && typeof this.cfg.option_display === 'object' ? this.cfg.option_display : {};
    Object.keys(od).forEach(function (name) {
      var i = od[name] && od[name].info;
      if (!i) return;
      add({ option: name, depends_on: (typeof i === 'object' && i.depends_on) || od[name].depends_on, key: typeof i === 'object' ? i.key : null });
    });
    this._infos = list;
    return list;
  };

  Configurator.prototype.infoFor = function (name) {
    return this.infoList().filter(function (c) {
      return c.option === name;
    })[0];
  };

  Configurator.prototype.chosenInfo = function (c) {
    if (!c || !c.option) return null;
    var v = this.sel(c.option);
    if (!v) return null;
    var map = (this.data.optionInfo || {})[c.key || c.option] || {};
    var dv = c.depends_on && this.options.indexOf(c.depends_on) > -1 ? this.sel(c.depends_on) : null;
    return (dv && map[dv + ' / ' + v]) || map[v] || null;
  };

  function num(x) {
    var n = parseFloat(x);
    return isNaN(n) ? String(x) : String(parseFloat(n.toFixed(2)));
  }

  /* "fabric" / "leather" for the value that shows a requirement step (explicit map in "requirement", else by name) */
  Configurator.prototype.materialKind = function (def) {
    var c = this.conds(def.show_if).filter(function (x) {
      return x.option;
    })[0];
    var v = c ? this.sel(c.option) : '';
    var r = def.requirement;
    if (r && typeof r === 'object' && r[v]) return r[v];
    if (/leather|\bCOL\b/i.test(v || '')) return 'leather';
    if (/fabric|\bCOF\b/i.test(v || '')) return 'fabric';
    return null;
  };

  function hasQty(i) {
    return !!i && (i.fabric_m != null || i.leather_m2 != null);
  }

  /* Where the own-material quantity comes from: the first info option whose chosen value has fabric_m / leather_m2,
     else sbs.option_info["_product"] (single items), else a hint naming the info option still to choose. */
  Configurator.prototype.reqSource = function () {
    var self = this;
    var all = this.data.optionInfo || {};
    var infos = this.infoList();
    for (var k = 0; k < infos.length; k++) {
      var i = this.chosenInfo(infos[k]);
      if (hasQty(i)) return { info: i, option: infos[k].option };
    }
    if (hasQty(all._product)) return { info: all._product, option: null };
    var wait = infos.filter(function (c) {
      var map = all[c.key || c.option] || {};
      return (
        !self.chosenInfo(c) &&
        Object.keys(map).some(function (x) {
          return hasQty(map[x]);
        })
      );
    })[0];
    return wait ? { info: null, option: wait.option } : null;
  };

  Configurator.prototype.updateInfo = function () {
    var self = this;
    this.infoList().forEach(function (c) {
      var st = self.od[c.option];
      if (!st || !st.infoEl) return;
      var info = self.chosenInfo(c);
      var lines = [];
      if (info && info.dimensions) lines.push('Dimensions: ' + info.dimensions);
      if (info && info.packaging) lines.push('Packaging: ' + info.packaging);
      if (info && info.note) lines.push(String(info.note));
      st.infoEl.textContent = lines.join('\n');
      st.infoEl.hidden = !lines.length;
    });
    var src = this.reqSource();
    this.steps.forEach(function (s) {
      if (!s.reqEl) return;
      var kind = self.materialKind(s.def);
      var t = s.def.requirement_text || {};
      var text = '';
      var info = src && src.info;
      var what = 'this ' + (src && src.option ? String(src.option).toLowerCase() : 'item');
      if (!src) text = '';
      else if (!info) {
        var o = String(src.option).toLowerCase();
        text = s.def.requirement_hint || 'Choose ' + (/^[aeiou]/.test(o) ? 'an ' : 'a ') + o + ' to see the required quantity.';
      } else if (kind === 'fabric' && info.fabric_m != null) {
        text = (t.fabric || 'Required for ' + what + ': {fabric_m} m fabric').replace('{fabric_m}', num(info.fabric_m));
      } else if (kind === 'leather' && info.leather_m2 != null) {
        text = (t.leather || 'Required for ' + what + ': {leather_m2} m\u00b2 usable leather').replace('{leather_m2}', num(info.leather_m2));
      }
      s.reqEl.textContent = text;
      s.reqEl.hidden = !text;
      s.reqEl.classList.toggle('sbs-hint', !!src && !info);
      var cond = (kind && (s.def.conditions || {})[kind]) || '';
      s.condEl.textContent = cond;
      s.condEl.hidden = !cond;
    });
  };

  Configurator.prototype.buildSelect = function (s) {
    var self = this;
    var values = s.def.values || [];
    if (!values.length) return false;
    var select = el(
      'select',
      {
        class: 'sbs-select',
        id: s.key + '-input',
        name: this.propName(s),
        form: this.formAttr(),
        'aria-labelledby': s.key + '-label',
        onchange: function () {
          self.clearError(s);
          s.valueEl.textContent = select.value ? ': ' + select.value : '';
        },
      },
      [el('option', { value: '', text: 'Choose an option' })].concat(
        values.map(function (v) {
          return el('option', { value: v, text: v });
        })
      )
    );
    s.inputs.push(select);
    s.focusEl = select;
    s.isComplete = function () {
      return select.value !== '';
    };
    s.message = 'Please choose an option.';
    s.wrap.appendChild(select);
  };

  Configurator.prototype.buildRadio = function (s) {
    var self = this;
    var values = s.def.values || [];
    if (!values.length) return false;
    var fs = el('fieldset', {
      class: 'product-form__input product-form__input--pill sbs-pills',
      'aria-labelledby': s.key + '-label',
    });
    values.forEach(function (v, vi) {
      var id = s.key + '-r' + vi;
      var input = el('input', {
        type: 'radio',
        id: id,
        name: self.propName(s),
        value: v,
        form: self.formAttr(),
        onchange: function () {
          self.clearError(s);
          s.valueEl.textContent = ': ' + v;
        },
      });
      s.inputs.push(input);
      fs.appendChild(input);
      fs.appendChild(el('label', { for: id, text: v }));
    });
    s.focusEl = s.inputs[0];
    s.isComplete = function () {
      return s.inputs.some(function (r) {
        return r.checked;
      });
    };
    s.message = 'Please choose an option.';
    s.wrap.appendChild(fs);
  };

  Configurator.prototype.buildMaterial = function (s) {
    var self = this;
    s.cols = el('fieldset', {
      class: 'product-form__input product-form__input--pill sbs-pills sbs-cols',
      'aria-label': s.def.label + ': collection',
    });
    s.info = el('p', { class: 'sbs-info', hidden: true });
    s.sw = el('div', { class: 'sbs-swatches', role: 'group', 'aria-label': s.def.label + ': colour' });
    s.code = el('input', {
      type: 'text',
      class: 'sbs-input',
      id: s.key + '-code',
      placeholder: 'Colour / code',
      'aria-label': 'Colour / code',
      maxlength: '120',
      autocomplete: 'off',
      oninput: function () {
        self.clearError(s);
        self.updateMaterial(s);
      },
    });
    s.codeWrap = el('div', { class: 'sbs-code', hidden: true }, [s.code]);
    s.note = el('p', { class: 'sbs-note', hidden: true });
    s.hidden = el('input', { type: 'hidden', name: this.propName(s), form: this.formAttr(), value: '' });
    s.inputs.push(s.hidden);
    /* selected-material line with an "Enlarge" button (opens the chosen swatch, or the first one) */
    s.zoomText = el('span', { class: 'sbs-zoombar__text' });
    s.zoomBtn = el(
      'button',
      {
        type: 'button',
        class: 'sbs-zoombar__btn',
        onclick: function (e) {
          e.preventDefault();
          e.stopPropagation();
          var i = s.colourIdx > -1 && s.zoomList.indexOf(s.colourIdx) > -1 ? s.colourIdx : s.zoomList[0];
          if (i != null) self.openZoom(s, i, s.zoomBtn);
        },
      },
      [zoomIcon(), el('span', { text: 'Enlarge' })]
    );
    s.zoomBar = el('div', { class: 'sbs-zoombar', hidden: true }, [s.zoomBtn, s.zoomText]);
    s.btns = [];
    s.zoomList = [];
    [s.cols, s.info, s.sw, s.zoomBar, s.codeWrap, s.note, s.hidden].forEach(function (n) {
      s.wrap.appendChild(n);
    });
    s.isComplete = function () {
      return s.hidden.value !== '';
    };
    s.focusEl = null;
  };

  /* ---------- material logic ---------- */

  function lc(x) {
    return String(x == null ? '' : x).trim().toLowerCase();
  }

  function toSet(list) {
    if (list == null || list === '') return null;
    var set = {};
    (Array.isArray(list) ? list : [list]).forEach(function (x) {
      set[lc(x)] = true;
    });
    return set;
  }

  function colourHit(set, c) {
    return !!(set[lc(c.code)] || set[lc(c.name)] || set[lc(c.name + ' ' + c.code)]);
  }

  /* Group as shown by a step: "allowed" (alias "codes") / "exclude" filter colours by code or name,
     "collections" / "exclude_collections" filter collections by name. Collections left without colours are dropped. */
  Configurator.prototype.stepGroup = function (s, handle) {
    var g = this.groups[handle];
    if (!g) return null;
    s.fg = s.fg || {};
    if (s.fg[handle] !== undefined) return s.fg[handle];
    var d = s.def;
    var allow = toSet(d.allowed != null ? d.allowed : d.codes);
    var excl = toSet(d.exclude);
    var cIn = toSet(d.collections);
    var cOut = toSet(d.exclude_collections);
    var cols = (g.collections || [])
      .filter(function (c) {
        return (!cIn || cIn[lc(c.name)]) && !(cOut && cOut[lc(c.name)]);
      })
      .map(function (c) {
        var all = c.colours || [];
        if (!allow && !excl) return c;
        var keep = all.filter(function (x) {
          return (!allow || colourHit(allow, x)) && !(excl && colourHit(excl, x));
        });
        if (all.length && !keep.length) return null;
        var o = {};
        Object.keys(c).forEach(function (k) {
          o[k] = c[k];
        });
        o.colours = keep;
        return o;
      })
      .filter(Boolean);
    var out = null;
    if (cols.length) {
      out = {};
      Object.keys(g).forEach(function (k) {
        out[k] = g[k];
      });
      out.collections = cols;
    }
    s.fg[handle] = out;
    return out;
  };

  Configurator.prototype.setGroup = function (s, handle, ctx) {
    if (s.handle === handle && s.ctx === ctx) return;
    s.handle = handle;
    s.ctx = ctx;
    s.group = this.stepGroup(s, handle);
    s.propLabel = this.materialLabel(s);
    s.hidden.name = this.propName(s);
    s.titleEl.textContent = s.propLabel;
    var cols = (s.group && s.group.collections) || [];
    var first = this.pre || cols.length < 2 ? 0 : -1;
    s.colIdx = first;
    s.colourIdx = -1;
    s.code.value = '';
    this.clearError(s);
    this.renderCollections(s, first);
    this.selectCollection(s, first);
  };

  Configurator.prototype.renderCollections = function (s, first) {
    var self = this;
    var cols = s.group.collections || [];
    s.cols.textContent = '';
    s.cols.hidden = cols.length < 2;
    cols.forEach(function (c, ci) {
      var id = s.key + '-c' + ci;
      s.cols.appendChild(
        el('input', {
          type: 'radio',
          id: id,
          name: s.key + '-col',
          value: String(ci),
          form: 'sbs-no-form',
          checked: ci === first,
          onchange: function () {
            self.clearError(s);
            self.selectCollection(s, ci);
          },
        })
      );
      s.cols.appendChild(el('label', { for: id, text: c.name }));
    });
  };

  Configurator.prototype.selectCollection = function (s, ci) {
    var self = this;
    s.colIdx = ci;
    s.colourIdx = -1;
    s.code.value = '';
    var col = (s.group.collections || [])[ci];
    s.sw.textContent = '';
    s.focusEl = null;
    if (!col) {
      s.btns = [];
      s.zoomList = [];
      s.zoomBar.hidden = true;
      s.info.hidden = true;
      s.sw.hidden = true;
      s.codeWrap.hidden = true;
      this.updateMaterial(s);
      return;
    }
    s.info.textContent = col.info || '';
    s.info.hidden = !col.info;
    var colours = col.colours || [];
    s.sw.hidden = !colours.length;
    s.btns = [];
    /* zoom list: colours with a swatch image, in display order (lightbox prev / next stays within this collection) */
    s.zoomList = [];
    colours.forEach(function (c, i) {
      if (c.img) s.zoomList.push(i);
    });
    colours.forEach(function (c, i) {
      var title = c.name + (c.code && c.code !== c.name ? ' (' + c.code + ')' : '');
      var visual = c.img || c.hex;
      var b = el('button', {
        type: 'button',
        class: 'sbs-swatch' + (visual ? '' : ' sbs-swatch--chip'),
        title: title,
        'aria-label': title,
        'aria-pressed': 'false',
        onclick: function () {
          s.colourIdx = i;
          self.clearError(s);
          s.btns.forEach(function (x, xi) {
            x.setAttribute('aria-pressed', xi === i ? 'true' : 'false');
            if (x.parentNode && x.parentNode !== s.sw) x.parentNode.classList.toggle('is-selected', xi === i);
          });
          self.updateMaterial(s);
        },
      });
      if (c.img) b.style.backgroundImage = 'url("' + c.img + '")';
      else if (c.hex) b.style.backgroundColor = c.hex;
      else b.textContent = c.name;
      s.btns.push(b);
      if (c.img) {
        /* separate (non nested) magnifier button: opens the large view, never selects */
        var z = el(
          'button',
          {
            type: 'button',
            class: 'sbs-swatch-zoom',
            tabindex: '-1',
            title: 'Enlarge ' + title,
            'aria-label': 'Enlarge ' + title,
            onclick: function (e) {
              e.preventDefault();
              e.stopPropagation();
              self.openZoom(s, i, z);
            },
          },
          [zoomIcon()]
        );
        s.sw.appendChild(el('span', { class: 'sbs-swatch-cell' }, [b, z]));
      } else s.sw.appendChild(b);
    });
    s.focusEl = s.btns[0] || null;
    s.zoomBar.hidden = !s.zoomList.length;
    var showCode = !!col.free_code || !colours.length;
    s.codeWrap.hidden = !showCode;
    if (!s.focusEl && showCode) s.focusEl = s.code;
    this.updateMaterial(s);
  };

  Configurator.prototype.updateMaterial = function (s) {
    var col = s.group && (s.group.collections || [])[s.colIdx];
    var c = col && s.colourIdx > -1 ? col.colours[s.colourIdx] : null;
    var code = s.code.value.trim();
    var val = '';
    var shown = '';
    /* The variant already carries the group (e.g. "Fabric P2"): the property only holds the colour.
       The collection is added in brackets only for non fabric/leather groups whose colour name lacks it. */
    var fl = /^(fabric|leather)/i.test((s.group && s.group.name) || '');
    if (col) {
      if (c) {
        var addCol = col.name && !fl && c.name.toLowerCase().indexOf(col.name.toLowerCase()) === -1;
        val = c.name + (addCol ? ' (' + col.name + ')' : '');
        shown = c.name;
        if (code) val += ', colour code ' + code;
      } else if (code) {
        val = col.name + ', colour code ' + code;
        shown = col.name + ' ' + code;
      }
    }
    s.hidden.value = val;
    s.valueEl.textContent = shown ? ': ' + shown : '';
    s.note.textContent = (c && c.note) || '';
    s.note.hidden = !(c && c.note);
    if (s.zoomText) {
      s.zoomText.textContent = c && c.img ? zoomLabel(c, col) : 'Use the magnifier to view a material large.';
      s.zoomText.classList.toggle('is-hint', !(c && c.img));
    }
    s.message = !col
      ? 'Please choose a collection.'
      : !(col.colours || []).length
      ? 'Please enter the colour / code.'
      : 'Please choose a colour.';
  };

  /* ---------- material zoom: large view of a swatch image (lightbox shared by all material steps) ---------- */

  var SVG = 'http://www.w3.org/2000/svg';

  function svgIcon(paths) {
    var svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'sbs-icon');
    paths.forEach(function (d) {
      var p = document.createElementNS(SVG, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  function zoomIcon() {
    return svgIcon(['M10.5 4a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13z', 'M15.3 15.3L20 20', 'M10.5 7.5v6M7.5 10.5h6']);
  }

  /* large rendition: liquid gives c.zoom (image_url width 1600); fallback rewrites the swatch URL's width parameter */
  function bigUrl(c) {
    if (c.zoom) return c.zoom;
    var u = String(c.img || '');
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=1600');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
  }

  /* expected pixel size of bigUrl(c): liquid zw / zh (natural size), capped at the 1600 px rendition; null when unknown */
  function zoomDims(c) {
    var w = +c.zw || 0;
    var h = +c.zh || 0;
    if (!w || !h) return null;
    return w > 1600 ? [1600, Math.round((h * 1600) / w)] : [w, h];
  }

  /* never upscale: the frame is the image's natural pixel size, shrunk only to fit the stage */
  function layoutZoom() {
    if (!LB || LB.root.hidden) return;
    var d = LB.dims;
    var f = LB.frame.style;
    if (!d) {
      f.width = f.height = '100%';
      return;
    }
    var k = Math.min(1, LB.stage.clientWidth / d[0], LB.stage.clientHeight / d[1]);
    f.width = Math.floor(d[0] * k) + 'px';
    f.height = Math.floor(d[1] * k) + 'px';
  }

  /* "Aure 06-107 \u00b7 Aure": code and collection only when the colour name does not already contain them */
  function zoomLabel(c, col) {
    var n = ' ' + lc(c.name).replace(/[(),]/g, ' ') + ' ';
    var has = function (x) {
      return n.indexOf(' ' + lc(x) + ' ') > -1;
    };
    var t = c.name;
    if (c.code && !has(c.code)) t += ' \u00b7 ' + c.code;
    if (col && col.name && !has(col.name)) t += ' \u00b7 ' + col.name;
    return t;
  }

  /* true when a click on the (object-fit: contain) image lands in its empty letterbox area */
  function offImage(e) {
    var t = e.target;
    if (t !== LB.img && t !== LB.low) return false;
    var im = LB.img.naturalWidth ? LB.img : LB.low;
    var nw = im.naturalWidth;
    var nh = im.naturalHeight;
    if (!nw || !nh) return false;
    var r = t.getBoundingClientRect();
    var k = Math.min(r.width / nw, r.height / nh);
    var x0 = r.left + (r.width - nw * k) / 2;
    var y0 = r.top + (r.height - nh * k) / 2;
    return e.clientX < x0 || e.clientX > x0 + nw * k || e.clientY < y0 || e.clientY > y0 + nh * k;
  }

  var LB = null;

  function lightbox() {
    if (LB) return LB;
    LB = {};
    var close = function () {
      closeZoom();
    };
    LB.low = el('img', { class: 'sbs-lb__low', alt: '', 'aria-hidden': 'true' });
    LB.img = el('img', { class: 'sbs-lb__img', alt: '' });
    LB.img.addEventListener('load', function () {
      if (LB.img.naturalWidth) LB.dims = [LB.img.naturalWidth, LB.img.naturalHeight];
      layoutZoom();
      LB.stage.classList.add('is-loaded');
    });
    LB.frame = el('div', { class: 'sbs-lb__frame' }, [LB.low, LB.img]);
    window.addEventListener('resize', layoutZoom);
    LB.prev = el('button', { type: 'button', class: 'sbs-lb__nav sbs-lb__nav--prev', 'aria-label': 'Previous material', onclick: function () { navZoom(-1); } }, [svgIcon(['M15 5l-7 7 7 7'])]);
    LB.next = el('button', { type: 'button', class: 'sbs-lb__nav sbs-lb__nav--next', 'aria-label': 'Next material', onclick: function () { navZoom(1); } }, [svgIcon(['M9 5l7 7-7 7'])]);
    LB.stage = el('div', { class: 'sbs-lb__stage' }, [LB.frame, LB.prev, LB.next]);
    LB.closeBtn = el('button', { type: 'button', class: 'sbs-lb__close', 'aria-label': 'Close', onclick: close }, [svgIcon(['M6 6l12 12M18 6L6 18'])]);
    LB.name = el('p', { class: 'sbs-lb__name', id: 'sbs-lb-name' });
    LB.details = el('p', { class: 'sbs-lb__details' });
    LB.count = el('p', { class: 'sbs-lb__count' });
    LB.select = el('button', {
      type: 'button',
      class: 'sbs-lb__select',
      onclick: function () {
        var s = LB.s;
        var i = s.zoomList[LB.pos];
        if (s.colourIdx !== i && s.btns[i]) s.btns[i].click();
        LB.returnTo = s.btns[i];
        closeZoom();
      },
    });
    LB.meta = el('div', { class: 'sbs-lb__meta' }, [el('div', { class: 'sbs-lb__text' }, [LB.name, LB.details, LB.count]), LB.select]);
    LB.panel = el('div', { class: 'sbs-lb__panel' }, [LB.stage, LB.meta]);
    LB.root = el('div', { class: 'sbs-lb', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'sbs-lb-name', hidden: true }, [LB.closeBtn, LB.panel]);
    /* click outside the image / caption closes */
    LB.root.addEventListener('click', function (e) {
      if (e.target === LB.root || e.target === LB.stage || e.target === LB.panel || offImage(e)) closeZoom();
    });
    /* swipe left / right on touch screens */
    var sx = null;
    var sy = 0;
    LB.stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return (sx = null);
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
    }, { passive: true });
    LB.stage.addEventListener('touchend', function (e) {
      if (sx === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) navZoom(dx < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (LB.root.hidden) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeZoom();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        navZoom(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        navZoom(1);
      } else if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(LB.root.querySelectorAll('button'), function (b) {
          return !b.hidden && b.offsetParent !== null;
        });
        if (!f.length) return;
        var at = f.indexOf(document.activeElement);
        if (e.shiftKey && at <= 0) {
          e.preventDefault();
          f[f.length - 1].focus();
        } else if (!e.shiftKey && (at === -1 || at === f.length - 1)) {
          e.preventDefault();
          f[0].focus();
        }
      }
    });
    document.body.appendChild(LB.root);
    return LB;
  }

  function renderZoom() {
    var s = LB.s;
    var col = s.group && (s.group.collections || [])[s.colIdx];
    var i = s.zoomList[LB.pos];
    var c = col && col.colours[i];
    if (!c) return closeZoom();
    var n = s.zoomList.length;
    LB.stage.classList.remove('is-loaded');
    LB.low.src = c.img;
    LB.img.removeAttribute('src');
    LB.img.alt = c.name + (c.code ? ' ' + c.code : '');
    LB.dims = zoomDims(c);
    LB.img.src = bigUrl(c);
    if (LB.img.complete && LB.img.naturalWidth) {
      LB.dims = [LB.img.naturalWidth, LB.img.naturalHeight];
      LB.stage.classList.add('is-loaded');
    }
    layoutZoom();
    LB.name.textContent = c.name;
    var d = [];
    if (c.code && c.code !== c.name) d.push('Code ' + c.code);
    if (col.name) d.push('Collection ' + col.name);
    if (s.group.name && s.group.name !== col.name) d.push(s.group.name);
    LB.details.textContent = d.join(' \u00b7 ');
    LB.count.textContent = n > 1 ? LB.pos + 1 + ' / ' + n : '';
    LB.count.hidden = n < 2;
    LB.prev.hidden = LB.next.hidden = n < 2;
    var on = s.colourIdx === i;
    LB.select.textContent = on ? 'Selected' : 'Select this ' + String(s.propLabel || s.def.label || 'material').toLowerCase();
    LB.select.classList.toggle('is-selected', on);
    LB.select.setAttribute('aria-pressed', on ? 'true' : 'false');
    /* warm the neighbours */
    [LB.pos - 1, LB.pos + 1].forEach(function (p) {
      var k = s.zoomList[(p + n) % n];
      if (n > 1 && col.colours[k]) new Image().src = bigUrl(col.colours[k]);
    });
  }

  function navZoom(d) {
    if (!LB || LB.root.hidden || !LB.s) return;
    var n = LB.s.zoomList.length;
    if (n < 2) return;
    LB.pos = (LB.pos + d + n) % n;
    renderZoom();
  }

  function closeZoom() {
    if (!LB || LB.root.hidden) return;
    LB.root.hidden = true;
    document.documentElement.classList.remove('sbs-lb-open');
    LB.img.removeAttribute('src');
    var r = LB.returnTo;
    LB.s = null;
    LB.returnTo = null;
    if (r && r.focus && document.contains(r)) r.focus({ preventScroll: true });
  }

  Configurator.prototype.openZoom = function (s, i, opener) {
    var pos = s.zoomList.indexOf(i);
    if (pos < 0) return;
    lightbox();
    LB.s = s;
    LB.pos = pos;
    /* the magnifier is not in the tab order: give focus back to the swatch itself */
    LB.returnTo = opener && opener.classList.contains('sbs-swatch-zoom') ? s.btns[i] : opener;
    LB.root.style.setProperty('--sbs-accent', getComputedStyle(this.root).getPropertyValue('--sbs-accent') || '#ed1c24');
    renderZoom();
    LB.root.hidden = false;
    document.documentElement.classList.add('sbs-lb-open');
    layoutZoom();
    LB.closeBtn.focus({ preventScroll: true });
  };

  /* ---------- variant tracking ---------- */

  Configurator.prototype.readCurrent = function () {
    var vs = this.liveSelects();
    var scope = vs || this.variantScope();
    var pre = vs ? '' : 'variant-selects ';
    var cur = this.current.slice();
    var found = false;
    /* Dawn radio names are "<option>-<position>", sometimes with trailing whitespace: compare trimmed */
    var checked = Array.prototype.slice.call(scope.querySelectorAll(pre + 'input[type="radio"]:checked'));
    this.options.forEach(function (name, idx) {
      var want = name + '-' + (idx + 1);
      var r = checked.filter(function (x) {
        return x.name.trim() === want;
      })[0];
      if (r) {
        cur[idx] = r.value;
        found = true;
        return;
      }
      var sel = scope.querySelector(pre + 'select[name="' + esc('options[' + name + ']') + '"]');
      if (sel) {
        cur[idx] = sel.value;
        found = true;
      }
    });
    if (!found) {
      var j = scope.querySelector(pre + '[data-selected-variant]');
      try {
        var v = j && JSON.parse(j.textContent);
        if (v && v.options) cur = v.options.slice();
      } catch (e) {}
    }
    this.current = cur;
    return cur;
  };

  Configurator.prototype.optionValue = function (name) {
    var idx = this.options.indexOf(name);
    return idx > -1 ? this.current[idx] : undefined;
  };

  /* Value the customer explicitly chose (preselect off) or the theme's current value (preselect on) */
  Configurator.prototype.sel = function (name) {
    if (Object.prototype.hasOwnProperty.call(this.single, name)) return this.single[name];
    /* options without a configurator control stay on the theme's own picker */
    return this.pre || !this.od[name] ? this.optionValue(name) : this.chosen[name];
  };

  Configurator.prototype.allChosen = function () {
    var self = this;
    return this.options.every(function (o) {
      var st = self.od[o];
      return (st && st.present === false) || !!self.sel(o);
    });
  };

  /* show_if: one condition or a list (all must hold). Condition: {"option": <variant option>} or {"step": <step id or label>}
     with "values" (one must match) and/or "not_values" (none may match). Option values match exactly; step values match
     case-insensitively on the chosen value (radio / select / text) or the chosen colour's code, name or collection. */
  Configurator.prototype.conds = function (x) {
    return (Array.isArray(x) ? x : x ? [x] : []).filter(function (c) {
      return c && typeof c === 'object' && (c.option || c.step);
    });
  };

  Configurator.prototype.stepTokens = function (ref) {
    var s = this.steps.filter(function (x) {
      return x.def.id === ref || x.def.label === ref;
    })[0];
    if (!s || !s.visible) return [];
    var d = s.def;
    if (d.type === 'material' || d.type === 'group') {
      var col = s.group && (s.group.collections || [])[s.colIdx];
      var c = col && s.colourIdx > -1 ? col.colours[s.colourIdx] : null;
      return [c && c.code, c && c.name, col && col.name].filter(Boolean).map(lc);
    }
    if (d.type === 'radio') {
      var r = s.inputs.filter(function (i) {
        return i.checked;
      })[0];
      return r ? [lc(r.value)] : [];
    }
    return s.inputs[0] && s.inputs[0].value ? [lc(s.inputs[0].value)] : [];
  };

  Configurator.prototype.condOk = function (c) {
    var vals;
    var norm = function (x) {
      return x;
    };
    if (c.option) vals = [this.sel(c.option)].filter(Boolean);
    else {
      vals = this.stepTokens(c.step);
      norm = lc;
    }
    var hit = function (list) {
      return (list || []).some(function (x) {
        return vals.indexOf(norm(x)) > -1;
      });
    };
    if (c.values && !hit(c.values)) return false;
    if (c.not_values && hit(c.not_values)) return false;
    return true;
  };

  Configurator.prototype.showIf = function (def) {
    var self = this;
    return this.conds(def.show_if).every(function (c) {
      return self.condOk(c);
    });
  };

  Configurator.prototype.refresh = function () {
    var self = this;
    this.readCurrent();
    this.syncChosen();
    this.steps.forEach(function (s) {
      var vis = self.showIf(s.def);
      if (s.def.type === 'material') {
        var v = self.sel(s.def.option);
        var map = self.valueGroup[s.def.option] || {};
        var h = map[v];
        vis = vis && !!(h && self.stepGroup(s, h));
        if (vis) self.setGroup(s, h, v);
        else {
          s.handle = null;
          s.hidden.value = '';
          s.valueEl.textContent = '';
        }
      } else if (s.def.type === 'group') {
        vis = vis && !!self.stepGroup(s, s.def.group);
        if (vis) self.setGroup(s, s.def.group, null);
      }
      s.visible = vis;
      s.wrap.hidden = !vis;
      s.inputs.forEach(function (i) {
        i.disabled = !vis;
      });
      if (!vis) self.clearError(s);
    });
    this.enhanceOptions();
    this.refreshBlocks();
    this.updatePrice();
  };

  Configurator.prototype.refreshSoon = function () {
    var self = this;
    clearTimeout(this.t);
    this.t = setTimeout(function () {
      self.refresh();
    }, 0);
  };

  /* ---------- option display: restyle native variant options (config.option_display) ---------- */

  Configurator.prototype.variantScope = function () {
    return (this.form && this.form.closest('product-info')) || this.root.closest('product-info') || document;
  };

  /* Dawn swaps in a new <variant-selects> on every variant change and hides the old one for a moment */
  Configurator.prototype.liveSelects = function () {
    var list = this.variantScope().querySelectorAll('variant-selects');
    for (var i = 0; i < list.length; i++) if (list[i].style.display !== 'none') return list[i];
    return list[0] || null;
  };

  Configurator.prototype.nativeOption = function (vs, name) {
    var want = name + '-' + (this.options.indexOf(name) + 1);
    var radios = Array.prototype.filter.call(vs.querySelectorAll('input[type="radio"]'), function (r) {
      return r.name.trim() === want;
    });
    if (radios.length) {
      return {
        box: radios[0].closest('fieldset') || radios[0].parentNode,
        values: radios.map(function (r) {
          return { value: r.value, off: r.classList.contains('disabled') || r.disabled };
        }),
      };
    }
    var sel = vs.querySelector('select[name="' + esc('options[' + name + ']') + '"]');
    if (!sel) return null;
    return {
      box: sel.closest('.product-form__input') || sel.parentNode,
      values: Array.prototype.map.call(sel.options, function (o) {
        return { value: o.value, off: o.disabled || o.classList.contains('disabled') };
      }),
    };
  };

  /* Select a value through the theme's own input so its variant, price and URL logic runs */
  Configurator.prototype.selectNative = function (name, value) {
    var vs = this.liveSelects();
    if (!vs) return;
    var want = name + '-' + (this.options.indexOf(name) + 1);
    var r = Array.prototype.filter.call(vs.querySelectorAll('input[type="radio"]'), function (x) {
      return x.name.trim() === want && x.value === value;
    })[0];
    if (r) {
      if (!r.checked) r.click();
      return;
    }
    var sel = vs.querySelector('select[name="' + esc('options[' + name + ']') + '"]');
    if (sel && sel.value !== value) {
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  Configurator.prototype.validValues = function (name, dep, depVal) {
    var i = this.options.indexOf(name);
    var d = this.options.indexOf(dep);
    var set = {};
    this.combos.forEach(function (v) {
      if (v[d] === depVal) set[v[i]] = true;
    });
    return set;
  };

  Configurator.prototype.enhanceOptions = function () {
    var self = this;
    var od = this.cfg.option_display && typeof this.cfg.option_display === 'object' ? this.cfg.option_display : {};
    var vs = this.liveSelects();
    if (!vs) return;
    this.options.forEach(function (name) {
      var st = self.od[name];
      var d = od[name];
      if (!st) {
        /* option outside the blocks: restyle in place (old behaviour) when option_display asks for it */
        if (!d || (d.style !== 'circles' && d.style !== 'tiles')) return;
        st = self.od[name] = self.odState(name, d);
        st.inline = true;
      }
      var nat = self.nativeOption(vs, name);
      st.present = !!(nat && nat.box && nat.box.parentNode);
      st.wrap.hidden = !st.present;
      if (!st.present) return;
      if (!nat.box.classList.contains('sbs-native-hidden')) nat.box.classList.add('sbs-native-hidden');
      if (st.inline && nat.box.nextSibling !== st.wrap) {
        nat.box.parentNode.insertBefore(st.wrap, nat.box.nextSibling);
        st.wrap.parentNode.insertBefore(st.err, st.wrap.nextSibling);
        if (st.infoEl) st.wrap.parentNode.insertBefore(st.infoEl, st.wrap.nextSibling);
      }
      if (Object.prototype.hasOwnProperty.call(self.single, name)) self.renderSingle(st, self.single[name]);
      else if (st.style === 'circles') self.renderCircles(st, nat.values);
      else if (st.style === 'tiles') self.renderTiles(st, nat.values);
      else self.renderPills(st, nat.values);
    });
    /* every native option lives in a block: hide the theme picker as a whole (no flash when Dawn swaps it) */
    var scope = this.variantScope();
    var allIn =
      this.options.length > 0 &&
      this.options.every(function (o) {
        return self.od[o] && self.od[o].block;
      });
    if (scope && scope.classList) scope.classList.toggle('sbs-vs-hidden', allIn);
    this.updateInfo();
    this.refreshBlocks();
    this.updatePrice();
  };

  Configurator.prototype.odState = function (name, d) {
    d = d || {};
    var style = d.style === 'circles' || d.style === 'tiles' ? d.style : 'pills';
    var st = { name: name, def: d, style: style, wrap: el('div', { class: 'sbs-od sbs-od--' + style, 'data-sbs-od': name }) };
    st.err = el('p', { class: 'sbs-error sbs-od__err', role: 'alert', hidden: true });
    st.message = d.message || 'Please choose the ' + String(name).toLowerCase() + '.';
    var z = parseFloat(d.image_zoom);
    if (style === 'tiles' && z > 0) st.wrap.style.setProperty('--sbs-tile-zoom', String(z));
    if (this.infoFor(name)) {
      st.infoEl = el('p', { class: 'sbs-info sbs-od__info', 'aria-live': 'polite', hidden: true });
    }
    return st;
  };

  Configurator.prototype.odLabel = function (st, cur) {
    return el('div', { class: 'form__label sbs-od__label' + (st.hideLabel ? ' sbs-vh' : '') }, [
      el('span', { text: st.name }),
      cur && st.style !== 'circles' ? el('span', { class: 'sbs-step__value', text: ': ' + cur }) : null,
    ]);
  };

  /* single-value option: plain info line ("Finish: Oak veneer"), complete from the start */
  Configurator.prototype.renderSingle = function (st, value) {
    var sig = JSON.stringify(['single', value]);
    if (st.sig === sig) return;
    st.sig = sig;
    st.wrap.textContent = '';
    st.wrap.appendChild(
      el('p', { class: 'sbs-info sbs-od__fixed' }, [el('span', { class: 'sbs-od__fixed-name', text: st.name + ': ' }), el('span', { text: value })])
    );
  };

  Configurator.prototype.renderPills = function (st, values) {
    var self = this;
    var cur = this.sel(st.name);
    var sig = JSON.stringify([values, cur]);
    if (st.sig === sig) return;
    st.sig = sig;
    st.wrap.textContent = '';
    st.wrap.appendChild(this.odLabel(st, cur));
    st.wrap.appendChild(
      el(
        'div',
        { class: 'sbs-pill-row', role: 'group', 'aria-label': st.name },
        values.map(function (v) {
          return self.odButton(st, v, [v.value], 'sbs-pill', cur);
        })
      )
    );
  };

  /* ---------- blocks: numbered cards grouping native options and steps (config.blocks) ---------- */

  Configurator.prototype.buildBlocks = function () {
    var self = this;
    var box = this.root.querySelector('[data-sbs-steps]');
    var od = this.cfg.option_display && typeof this.cfg.option_display === 'object' ? this.cfg.option_display : {};
    var used = {};
    var usedOpt = {};
    var list = [];
    function take(ref) {
      var r = String(ref);
      var pick = function (fn) {
        return self.steps.filter(function (s) {
          return !used[s.key] && fn(s);
        })[0];
      };
      return (
        pick(function (s) {
          return s.def.id === r || s.def.label === r;
        }) ||
        pick(function (s) {
          return s.def.type === r;
        })
      );
    }
    if (Array.isArray(this.cfg.blocks) && this.cfg.blocks.length) {
      this.cfg.blocks.forEach(function (b) {
        if (!b) return;
        var opts = (b.options || []).filter(function (o) {
          if (self.options.indexOf(o) < 0 || usedOpt[o]) return false;
          usedOpt[o] = true;
          return true;
        });
        var steps = [];
        (b.steps || []).forEach(function (r) {
          var s = take(r);
          if (!s) return;
          used[s.key] = true;
          steps.push(s);
        });
        if (opts.length || steps.length)
          list.push({ title: b.title || opts[0] || steps[0].def.label || 'Details', options: opts, steps: steps });
      });
    } else {
      /* default: one block per native option (with the steps tied to it), then one per remaining step */
      this.options.forEach(function (o) {
        usedOpt[o] = true;
        var steps = self.steps.filter(function (s) {
          return (
            !used[s.key] &&
            (s.def.option === o ||
              self.conds(s.def.show_if).some(function (c) {
                return c.option === o;
              }))
          );
        });
        steps.forEach(function (s) {
          used[s.key] = true;
        });
        list.push({ title: o, options: [o], steps: steps });
      });
    }
    /* steps not placed yet: a step shown by another step's value joins that step's block, the rest get their own block */
    this.steps.forEach(function (s) {
      if (used[s.key]) return;
      used[s.key] = true;
      var ref = self.conds(s.def.show_if).filter(function (c) {
        return c.step;
      })[0];
      var host =
        ref &&
        list.filter(function (b) {
          return b.steps.some(function (x) {
            return x.def.id === ref.step || x.def.label === ref.step;
          });
        })[0];
      if (host) host.steps.push(s);
      else list.push({ title: s.def.label || 'Details', options: [], steps: [s] });
    });
    box.classList.add('sbs-blocks');
    this.blocks = list.map(function (b) {
      var blk = { title: b.title, opts: [], steps: b.steps };
      blk.num = el('span', { class: 'sbs-block__num', 'aria-hidden': 'true' });
      blk.status = el('span', { class: 'sbs-block__status', text: 'Complete', hidden: true });
      blk.msg = el('p', { class: 'sbs-block__msg', hidden: true, text: 'Please complete this step.' });
      blk.body = el('div', { class: 'sbs-block__body' });
      blk.wrap = el('section', { class: 'sbs-block', 'aria-label': b.title, 'data-sbs-block': b.title }, [
        el('div', { class: 'sbs-block__head' }, [blk.num, el('h3', { class: 'sbs-block__title', text: b.title }), blk.status]),
        blk.msg,
        blk.body,
      ]);
      b.options.forEach(function (o) {
        var st = (self.od[o] = self.odState(o, od[o]));
        st.block = blk;
        st.hideLabel = o === b.title;
        blk.opts.push(st);
        blk.body.appendChild(st.wrap);
        if (st.infoEl) blk.body.appendChild(st.infoEl);
        blk.body.appendChild(st.err);
      });
      b.steps.forEach(function (s) {
        s.block = blk;
        if (s.def.label === b.title && s.def.type !== 'material') s.head.classList.add('sbs-vh');
        blk.body.appendChild(s.wrap);
      });
      box.appendChild(blk.wrap);
      return blk;
    });
  };

  var CHECK =
    '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  Configurator.prototype.refreshBlocks = function () {
    var self = this;
    var n = 0;
    (this.blocks || []).forEach(function (b) {
      var any = false;
      var done = true;
      b.opts.forEach(function (st) {
        if (!st.present) return;
        any = true;
        if (!self.sel(st.name)) done = false;
      });
      b.steps.forEach(function (s) {
        if (!s.visible) return;
        any = true;
        if (s.def.required && !s.isComplete()) done = false;
      });
      b.wrap.hidden = !any;
      if (!any) return;
      n++;
      if (b.n !== n || b.done !== done) {
        b.n = n;
        b.done = done;
        if (done) b.num.innerHTML = CHECK;
        else b.num.textContent = String(n);
      }
      b.wrap.classList.toggle('sbs-block--done', done);
      b.status.hidden = !done;
      if (done) {
        b.msg.hidden = true;
        b.wrap.classList.remove('sbs-block--error');
      }
    });
    this.updatePrice();
  };

  Configurator.prototype.refreshBlocksSoon = function () {
    var self = this;
    clearTimeout(this.bt);
    this.bt = setTimeout(function () {
      self.refreshBlocks();
    }, 0);
  };

  Configurator.prototype.odButton = function (st, v, text, cls, cur) {
    var self = this;
    return el(
      'button',
      {
        type: 'button',
        class: cls + (v.off ? ' is-unavailable' : ''),
        title: v.value,
        'aria-label': v.value,
        'aria-pressed': v.value === cur ? 'true' : 'false',
        onclick: function (e) {
          var b = e.currentTarget;
          Array.prototype.forEach.call(st.wrap.querySelectorAll('[aria-pressed]'), function (x) {
            x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
          });
          self.chosen[st.name] = v.value;
          self.clearOdError(st);
          self.syncChosen();
          self.selectNative(st.name, v.value);
          self.refreshSoon();
        },
      },
      text
    );
  };

  Configurator.prototype.renderCircles = function (st, values) {
    var self = this;
    var cur = this.sel(st.name);
    var sig = JSON.stringify([values, cur]);
    if (st.sig === sig) return;
    st.sig = sig;
    var byValue = {};
    values.forEach(function (v) {
      byValue[v.value] = v;
    });
    var listed = {};
    var wrap = st.wrap;
    wrap.textContent = '';
    wrap.appendChild(this.odLabel(st, cur));
    (st.def.rows || []).forEach(function (row) {
      var items = row.items || {};
      var pairs = Array.isArray(items)
        ? items.map(function (it) {
            return [it.value, it.label || it.value];
          })
        : Object.keys(items).map(function (k) {
            return [k, items[k]];
          });
      var btns = pairs
        .filter(function (p) {
          return byValue[p[0]];
        })
        .map(function (p) {
          listed[p[0]] = true;
          return self.odButton(st, byValue[p[0]], [String(p[1])], 'sbs-circle', cur);
        });
      if (!btns.length) return;
      wrap.appendChild(
        el('div', { class: 'sbs-circ-row' }, [
          row.title ? el('div', { class: 'sbs-circ-row__title', text: row.title }) : null,
          el('div', { class: 'sbs-circ-row__items', role: 'group', 'aria-label': row.title || st.name }, btns),
        ])
      );
    });
    var rest = values.filter(function (v) {
      return !listed[v.value];
    });
    if (rest.length) {
      wrap.appendChild(
        el(
          'div',
          { class: 'sbs-circ-row__items sbs-circ-rest' },
          rest.map(function (v) {
            return self.odButton(st, v, [v.value], 'sbs-swatch sbs-swatch--chip', cur);
          })
        )
      );
    }
    wrap.appendChild(el('p', { class: 'sbs-od__selected', 'aria-live': 'polite', text: cur || '' }));
  };

  Configurator.prototype.imageFor = function (st, depVal, value) {
    var all = this.data.optionImages || {};
    var map = all[st.def.images_key || st.name] || {};
    var url = (depVal != null && map[depVal + ' / ' + value]) || map[value] || '';
    if (url && /cdn\.shopify\.com|\/cdn\/shop\//.test(url) && !/[?&]width=/.test(url)) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    }
    return url;
  };

  Configurator.prototype.renderTiles = function (st, values) {
    var self = this;
    var dep = st.def.depends_on;
    var hasDep = dep && this.options.indexOf(dep) > -1;
    var depVal = hasDep ? this.sel(dep) : null;
    var cur = this.sel(st.name);
    var shown = values;
    if (hasDep && this.combosDone) {
      var ok = this.validValues(st.name, dep, depVal);
      shown = values.filter(function (v) {
        return ok[v.value];
      });
      /* Keep the hidden theme picker on an existing combination (the price stays "From" until the customer chooses).
         The customer's own element choice is cleared in syncChosen, never replaced. */
      var natDep = this.optionValue(dep);
      var natCur = this.optionValue(st.name);
      var natOk = this.validValues(st.name, dep, natDep);
      var natShown = values.filter(function (v) {
        return natOk[v.value];
      });
      if (natShown.length && !natOk[natCur]) {
        var key = natDep + '|' + natCur;
        if (st.autoKey !== key) {
          st.autoKey = key;
          this.selectNative(st.name, natShown[0].value);
        }
      }
    }
    var waiting = hasDep && !depVal;
    var sig = JSON.stringify([shown, cur, depVal, this.combosDone, waiting]);
    if (st.sig === sig) return;
    st.sig = sig;
    var wrap = st.wrap;
    wrap.textContent = '';
    wrap.appendChild(this.odLabel(st, cur));
    if (waiting) {
      wrap.appendChild(el('p', { class: 'sbs-hint', text: st.def.hint || 'Choose a ' + String(dep).toLowerCase() + ' first.' }));
      return;
    }
    wrap.appendChild(
      el(
        'div',
        { class: 'sbs-tiles', role: 'group', 'aria-label': st.name },
        shown.map(function (v) {
          var src = self.imageFor(st, depVal, v.value);
          return self.odButton(
            st,
            v,
            [
              src
                ? el('span', { class: 'sbs-tile__frame' }, [
                    el('img', { class: 'sbs-tile__img', src: src, alt: '', loading: 'lazy', decoding: 'async' }),
                  ])
                : null,
              el('span', { class: 'sbs-tile__label', text: v.value }),
            ],
            'sbs-tile',
            cur
          );
        })
      )
    );
  };

  /* Liquid only exposes the first 250 variants: fetch the rest from the sbs-variants alternate template */
  Configurator.prototype.loadVariants = function () {
    var self = this;
    if (this.combosDone || !this.data.handle) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pages = Math.ceil(this.data.variantsCount / 250);
    var reqs = [];
    for (var p = 2; p <= pages; p++) {
      reqs.push(
        fetch(root + 'products/' + encodeURIComponent(this.data.handle) + '?view=sbs-variants&page=' + p, {
          credentials: 'same-origin',
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (t) {
            return JSON.parse(t.trim()).variants || [];
          })
      );
    }
    Promise.all(reqs)
      .then(function (lists) {
        lists.forEach(function (l) {
          self.combos = self.combos.concat(l);
        });
        self.combosDone = true;
        self.enhanceOptions();
      })
      .catch(function (e) {
        console.warn('sbs-configurator: could not load all variant combinations, option filtering disabled', e);
      });
  };

  Configurator.prototype.observe = function () {
    var self = this;
    if (!Object.keys(this.od).length || !window.MutationObserver) return;
    var vs = this.liveSelects();
    var target = vs && vs.parentNode;
    if (!target) return;
    new MutationObserver(function () {
      clearTimeout(self.ot);
      self.ot = setTimeout(function () {
        self.readCurrent();
        self.enhanceOptions();
      }, 20);
    }).observe(target, { childList: true, subtree: true });
  };

  /* ---------- validation ---------- */

  Configurator.prototype.clearError = function (s) {
    s.errorEl.hidden = true;
    s.errorEl.textContent = '';
    s.wrap.classList.remove('sbs-step--error');
  };

  Configurator.prototype.clearOdError = function (st) {
    st.err.hidden = true;
    st.err.textContent = '';
    st.wrap.classList.remove('sbs-od--error');
  };

  /* Drop an explicit choice that no longer exists for the chosen value of the option it depends on */
  Configurator.prototype.syncChosen = function () {
    var self = this;
    if (this.pre || !this.combosDone) return;
    Object.keys(this.od).forEach(function (name) {
      var st = self.od[name];
      var dep = st.def && st.def.depends_on;
      if (!dep || self.options.indexOf(dep) < 0 || !self.chosen[name]) return;
      var ok = self.chosen[dep] ? self.validValues(name, dep, self.chosen[dep]) : {};
      if (!ok[self.chosen[name]]) delete self.chosen[name];
    });
  };

  /* Until every variant option is chosen: "From <lowest price>" instead of the default variant's price */
  Configurator.prototype.updatePrice = function () {
    if (this.pre) return;
    var form = this.form;
    if (form) {
      var incomplete = !this.isComplete();
      Array.prototype.forEach.call(form.querySelectorAll('button[type="submit"], [name="add"]'), function (b) {
        b.classList.toggle('sbs-atc-pending', incomplete);
      });
    }
    if (!this.data.priceFrom) return;
    /* Dawn price (#price-<section>) or an app price block (Infinite Options) */
    var scope = this.variantScope();
    var box = scope.querySelector('[id^="price-"]') || scope.querySelector('.infiniteoptions-price') || scope.querySelector('.price');
    /* no visible amount in the theme price (e.g. prices hidden for this visitor): show no "From" price either */
    if (!box || !/\d/.test(box.textContent)) {
      if (this.fromEl) this.fromEl.hidden = true;
      if (box) box.classList.remove('sbs-price-hidden');
      return;
    }
    var pending = !this.allChosen();
    if (!this.fromEl) {
      /* the shop's money format can carry app markup (e.g. <span hidewlm>): keep the text only */
      var amount = new DOMParser().parseFromString(String(this.data.priceFrom), 'text/html').body.textContent.trim();
      var span = el('span', { class: 'sbs-from__amount', text: 'From ' + amount });
      var ref = box.querySelector('.price-item--regular, .price-item') || box;
      var cs = window.getComputedStyle(ref);
      ['fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'lineHeight', 'color'].forEach(function (k) {
        span.style[k] = cs[k];
      });
      this.fromEl = el('div', { class: 'sbs-from', 'data-sbs-from': '' }, [span]);
    }
    if (box.nextSibling !== this.fromEl) box.parentNode.insertBefore(this.fromEl, box.nextSibling);
    box.classList.toggle('sbs-price-hidden', pending);
    this.fromEl.hidden = !pending;
  };

  Configurator.prototype.isComplete = function () {
    var self = this;
    var opts = Object.keys(this.od).every(function (n) {
      var st = self.od[n];
      return !st.present || !!self.sel(n);
    });
    return (
      opts &&
      this.steps.every(function (s) {
        return !s.visible || !s.def.required || s.isComplete();
      })
    );
  };

  Configurator.prototype.validate = function () {
    var self = this;
    var errs = [];
    this.syncChosen();
    this.refresh();
    (this.blocks || []).forEach(function (b) {
      b.wrap.classList.remove('sbs-block--error');
      b.msg.hidden = true;
    });
    var mark = function (blk) {
      if (!blk) return;
      blk.wrap.classList.add('sbs-block--error');
      blk.msg.hidden = false;
    };
    Object.keys(this.od).forEach(function (n) {
      var st = self.od[n];
      self.clearOdError(st);
      if (!st.present || self.sel(n)) return;
      st.err.textContent = st.message;
      st.err.hidden = false;
      st.wrap.classList.add('sbs-od--error');
      mark(st.block);
      errs.push({ wrap: st.wrap, focusEl: st.wrap.querySelector('button') });
    });
    this.steps.forEach(function (s) {
      self.clearError(s);
      if (!s.visible || !s.def.required || s.isComplete()) return;
      s.errorEl.textContent = s.message;
      s.errorEl.hidden = false;
      s.wrap.classList.add('sbs-step--error');
      mark(s.block);
      errs.push(s);
    });
    if (!errs.length) return true;
    errs.sort(function (a, b) {
      return a.wrap.compareDocumentPosition(b.wrap) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    var first = errs[0];
    first.wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (first.focusEl) {
      try {
        first.focusEl.focus({ preventScroll: true });
      } catch (e) {}
    }
    return false;
  };

  /* Optional fields left empty are not sent as empty cart properties (re-enabled by the next refresh) */
  Configurator.prototype.prune = function () {
    var self = this;
    var any = false;
    this.steps.forEach(function (s) {
      if (!s.visible || s.def.type === 'radio') return;
      s.inputs.forEach(function (i) {
        if (!i.disabled && !String(i.value || '').trim()) {
          i.disabled = true;
          any = true;
        }
      });
    });
    if (any) {
      clearTimeout(this.pt);
      this.pt = setTimeout(function () {
        self.refresh();
      }, 1000);
    }
  };

  Configurator.prototype.bind = function () {
    var self = this;
    ['click', 'input', 'change'].forEach(function (t) {
      self.root.addEventListener(t, function () {
        if (self.stepDeps) self.refreshSoon();
        else self.refreshBlocksSoon();
      });
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('variant-selects') || (t.name === 'id' && t.form === self.form)) self.refreshSoon();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        self.refreshSoon();
      });
    }
    if (!this.formId) return;
    document.addEventListener(
      'submit',
      function (e) {
        if (e.target !== self.form) return;
        if (!self.validate()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        } else self.prune();
      },
      true
    );
    var buyNow = '.shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button, [data-shopify="payment-button"]';
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target && e.target.closest ? e.target : null;
        var b = t && t.closest('button[type="submit"], input[type="submit"]');
        var hit = b && b.form && b.form === self.form;
        if (!hit && t) {
          var dyn = t.closest(buyNow);
          hit = !!(dyn && (self.form.contains(dyn) || self.variantScope().contains(dyn)));
        }
        if (!hit) return;
        if (!self.validate()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        } else self.prune();
      },
      true
    );
  };

  function init() {
    document.querySelectorAll('[data-sbs-config]:not(.sbs-config--ready)').forEach(function (root) {
      new Configurator(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
